const MODULE_NAME = 'fulcrum/containers/Report/Nvqual'

const MOUNT = MODULE_NAME + '/MOUNT'
const UNMOUNT = MODULE_NAME + '/UNMOUNT'

const FETCH_REPORT = MODULE_NAME + '/FETCH_REPORT'
const FETCH_REPORT_START = MODULE_NAME + '/FETCH_REPORT_START'
const FETCH_REPORT_SUCCESS = MODULE_NAME + '/FETCH_REPORT_SUCCESS'
const FETCH_REPORT_ERROR = MODULE_NAME + '/FETCH_REPORT_ERROR'

const UPDATE_REPORT = MODULE_NAME + '/UPDATE_REPORT'
const REMOVE_REPORT = MODULE_NAME + '/REMOVE_REPORT'
const CLEAR_REPORTS = MODULE_NAME + '/CLEAR_REPORTS'

const ON_SELECT_FILTER = MODULE_NAME + '/ON_SELECT_FILTER'
const ON_UNSELECT_FILTER = MODULE_NAME + '/ON_UNSELECT_FILTER'
const CLEAR_FILTER = MODULE_NAME + '/CLEAR_FILTER'

const UPDATE_QUERY = MODULE_NAME + '/UPDATE_QUERY'///
const UPDATE_QUERY_CHANGES = MODULE_NAME + '/UPDATE_QUERY_CHANGES'//
const UPDATE_QUERY_SOURCE = MODULE_NAME + '/UPDATE_QUERY_SOURCE'//
const RESET_QUERY = MODULE_NAME + '/RESET_QUERY'//


const FETCH_QUERY_SOURCE = MODULE_NAME + '/FETCH_QUERY_SOURCE'
const FETCH_QUERY_SOURCE_START = MODULE_NAME + '/FETCH_QUERY_SOURCE_START'
const FETCH_QUERY_SOURCE_SUCCESS = MODULE_NAME + '/FETCH_QUERY_SOURCE_SUCCESS'
const FETCH_QUERY_SOURCE_ERROR = MODULE_NAME + '/FETCH_QUERY_SOURCE_ERROR'

const UPDATE_BAR_RANGE = MODULE_NAME + '/UPDATE_BAR_RANGE'
const CLEAR_BAR_RANGE = MODULE_NAME + '/CLEAR_BAR_RANGE'

const UPDATE_SELECTED_POINT_THERMAL = MODULE_NAME + '/UPDATE_SELECTED_POINT_THERMAL'

const CLEAR_CHART_STATE = MODULE_NAME + '/CLEAR_CHART_STATE'

const ON_SELECT_MAX_THERMAL = MODULE_NAME + '/ON_SELECT_MAX_THERMAL'
const ON_SELECT_AVG_THERMAL = MODULE_NAME + '/ON_SELECT_AVG_THERMAL'
const ON_CLEAR_MAX_THERMAL = MODULE_NAME + '/ON_CLEAR_MAX_THERMAL'
const ON_CLEAR_AVG_THERMAL = MODULE_NAME + '/ON_CLEAR_AVG_THERMAL'
const ON_TOGGLE_MAX_THERMAL = MODULE_NAME + '/ON_TOGGLE_MAX_THERMAL'
const ON_TOGGLE_AVG_THERMAL = MODULE_NAME + '/ON_TOGGLE_AVG_THERMAL'

const ON_CHART_TABLE_LOADING_START = MODULE_NAME + '/ON_CHART_TABLE_LOADING_START'
const ON_CHART_TABLE_LOADING_END = MODULE_NAME + '/ON_CHART_TABLE_LOADING_END'

const chartsEnum = Object.freeze({
  THERMAL_TDP_GPU_TEMP: {
    value: 'thermal_tdp_gpu_temp',
  },
  THERMAL_TDP_MEM_TEMP: {
    value: 'thermal_tdp_mem_temp',
  },
  THERMAL_TDP_GPU_POWER: {
    value: 'thermal_tdp_gpu_power',
  },
  THERMAL_TDP_MAX_GPU_TEMP: {
    value: 'thermal_tdp_max_gpu_temp',
  },
  THERMAL_TDP_MAX_MEM_TEMP: {
    value: 'thermal_tdp_max_mem_temp',
  },
  THERMAL_TDP_MAX_GPU_POWER: {
    value: 'thermal_tdp_max_gpu_power',
  },
  NVLINK_DATA_EYE_Y: {
    value: 'nvlink_data_eye_y',
  },
  NVLINK_DATA_EYE_X: {
    value: 'nvlink_data_eye_x',
  },
  PEX_DATA_EYE_Y: {
    value: 'pex_data_eye_y',
  },
  PEX_DATA_EYE_X: {
    value: 'pex_data_eye_x',
  }
})

const histogramCharts = [
  chartsEnum.NVLINK_DATA_EYE_Y,
  chartsEnum.NVLINK_DATA_EYE_X,
  chartsEnum.PEX_DATA_EYE_Y,
  chartsEnum.PEX_DATA_EYE_X
]

const thermalCharts = [
  chartsEnum.THERMAL_TDP_GPU_TEMP,
  chartsEnum.THERMAL_TDP_MEM_TEMP,
  chartsEnum.THERMAL_TDP_GPU_POWER,
  chartsEnum.THERMAL_TDP_MAX_GPU_TEMP,
  chartsEnum.THERMAL_TDP_MAX_MEM_TEMP,
  chartsEnum.THERMAL_TDP_MAX_GPU_POWER,  
]

const chartsCategoryEnum = Object.freeze({
  THERMAL_TDP : {
    value: 'thermal_tdp',
    charts: [
      chartsEnum.THERMAL_TDP_GPU_TEMP,
      chartsEnum.THERMAL_TDP_MEM_TEMP,
      chartsEnum.THERMAL_TDP_GPU_POWER
    ]
  },
  THERMAL_TDP_MAX: {
    value: 'thermal_tdp_max',
    charts: [
      chartsEnum.THERMAL_TDP_MAX_GPU_TEMP,
      chartsEnum.THERMAL_TDP_MAX_MEM_TEMP,
      chartsEnum.THERMAL_TDP_MAX_GPU_POWER
    ]
  },
  NVLINK_DATA_EYE: {
    value: 'nvlink_data_eye',
    charts: [
      chartsEnum.NVLINK_DATA_EYE_Y,
      chartsEnum.NVLINK_DATA_EYE_X
    ]
  },
  PEX_DATA_EYE: {
    value: 'pex_data_eye',
    charts: [
      chartsEnum.PEX_DATA_EYE_Y,
      chartsEnum.PEX_DATA_EYE_X
    ]
  }
})

const queryEnum = Object.freeze({
  sku: {
    value: 'sku'
  }
})

export {
  MODULE_NAME,
  MOUNT,
  UNMOUNT,
  FETCH_REPORT,
  FETCH_REPORT_START,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_ERROR,
  UPDATE_REPORT,
  REMOVE_REPORT,
  CLEAR_REPORTS,
  ON_SELECT_FILTER,
  ON_UNSELECT_FILTER,
  CLEAR_FILTER,
  UPDATE_QUERY,
  UPDATE_QUERY_CHANGES,
  UPDATE_QUERY_SOURCE,
  RESET_QUERY,
  FETCH_QUERY_SOURCE,
  FETCH_QUERY_SOURCE_START,
  FETCH_QUERY_SOURCE_SUCCESS,
  FETCH_QUERY_SOURCE_ERROR,
  UPDATE_BAR_RANGE,
  CLEAR_BAR_RANGE,
  CLEAR_CHART_STATE,
  ON_SELECT_MAX_THERMAL,
  ON_SELECT_AVG_THERMAL,
  ON_CLEAR_MAX_THERMAL,
  ON_CLEAR_AVG_THERMAL,
  ON_TOGGLE_MAX_THERMAL,
  ON_TOGGLE_AVG_THERMAL,
  UPDATE_SELECTED_POINT_THERMAL,
  ON_CHART_TABLE_LOADING_START,
  ON_CHART_TABLE_LOADING_END,
  chartsCategoryEnum,
  chartsEnum,
  queryEnum,
  histogramCharts,
  thermalCharts
}